import { format } from 'date-fns'
import { startOfWorkDay } from '@/lib/shiftTime'
import { DashboardStore, useDashboardStore } from './_components/dashboardStore'

export const layoutConfig = {
  url: '/',
  overrideLinkHref: (href: string, storeState: DashboardStore) => {
    const now = format(startOfWorkDay(new Date()), 'yyyy-MM-dd')
    return storeState.dashboardPath({ from: now, to: now, shift: 'A' })
  },
  store: useDashboardStore,
} as const satisfies LayoutConfig
